export default {
  title: {
    id: 'shopping_assistant_title',
    defaultMessage: 'Ask me',
  },
  newChat: {
    id: 'shopping_assistant_new_chat_button_icon',
    defaultMessage: 'New conversation',
  },
  closeChat: {
    id: 'shopping_assistant_close_chat_button',
    defaultMessage: 'Close conversation',
  },
  newConversationDialogTitle: {
    id: 'shopping_assistant_new_conversation_dialog_title',
    defaultMessage: 'Are you sure?',
  },
  newConversationDialogDescription: {
    id: 'shopping_assistant_new_conversation_dialog_description',
    defaultMessage:
      'Doing this will start a new conversation and your current conversation will be lost.',
  },
  newConversationDialogPositiveButton: {
    id: 'shopping_assistant_new_conversation_dialog_positive_button',
    defaultMessage: 'Start new conversation',
  },
  newConversationDialogNegativeButton: {
    id: 'shopping_assistant_new_conversation_dialog_negative_button',
    defaultMessage: 'Cancel',
  },
} as const
